import React from 'react';
import CDMLogo from './CDMLogo';
import LlcLogo from './LlcLogo';

function Footer({ C, useBreakpoint, NAV_LINKS }) {
	const { isMobile, px } = useBreakpoint();
	return (
		<footer
			style={{
				background: C.bgDark,
				color: '#A0B0AE',
				padding: `60px ${px} 40px`,
				marginTop: 50,
			}}
		>
			<div
				style={{
					display: 'grid',
					gridTemplateColumns: isMobile ? '1fr' : '2fr 1fr 1fr',
					gap: isMobile ? 40 : 60,
					marginBottom: 48,
				}}
			>
				<div>
					<LlcLogo />

					{/* CDM sub-brand */}
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: 12,
							marginBottom: 18,
						}}
					>
						<CDMLogo size={34} />
						<div>
							<div
								style={{
									fontFamily: 'DM Mono',
									fontSize: 12,
									color: C.tealLight,
									letterSpacing: '0.1em',
								}}
							>
								Census Disruption Model
							</div>
							<div style={{ fontSize: 11, color: '#6A8A86', marginTop: 2 }}>
								Historical Racial Violence Research
							</div>
						</div>
					</div>

					<p
						style={{
							fontSize: 13,
							lineHeight: 1.8,
							color: '#6A8A86',
							maxWidth: 320,
						}}
					>
						A probabilistic framework for identifying disrupted lives in
						historical mass violence. Built in service of community memory, not
						in place of it.
					</p>
				</div>

				{!isMobile && (
					<>
						<div>
							<div
								style={{
									fontFamily: 'DM Mono',
									fontSize: 10,
									letterSpacing: '0.15em',
									textTransform: 'uppercase',
									color: C.tealLight,
									marginBottom: 18,
								}}
							>
								Navigate
							</div>
							{NAV_LINKS.map(({ label }) => (
								<div
									key={label}
									style={{ fontSize: 13, marginBottom: 10, color: '#6A8A86' }}
								>
									{label}
								</div>
							))}
						</div>
						<div>
							<div
								style={{
									fontFamily: 'DM Mono',
									fontSize: 10,
									letterSpacing: '0.15em',
									textTransform: 'uppercase',
									color: C.tealLight,
									marginBottom: 18,
								}}
							>
								Principle
							</div>
							<p
								style={{
									fontSize: 13,
									fontStyle: 'italic',
									color: '#6A8A86',
									lineHeight: 1.8,
								}}
							>
								"The data belongs to the community."
							</p>
							<div style={{ marginTop: 20, fontSize: 12, color: '#4A6A66' }}>
								Open to collaboration.
								<br />
								Committed to correction.
							</div>
						</div>
					</>
				)}
			</div>

			<div
				style={{
					borderTop: '1px solid #1E3230',
					paddingTop: 20,
					display: 'flex',
					flexDirection: isMobile ? 'column' : 'row',
					gap: 8,
					justifyContent: 'space-between',
					alignItems: isMobile ? 'flex-start' : 'center',
				}}
			>
				{/* Updated: year corrected to 2025, LLC name added */}
				<div style={{ fontSize: 11, color: '#4A6A66', fontFamily: 'DM Mono' }}>
					© 2025 Center for the Uncounted, LLC
				</div>
				<div style={{ fontSize: 11, color: '#4A6A66' }}>
					Direction, not declaration.
				</div>
			</div>
		</footer>
	);
}

export default Footer;
